import { post } from "api/events";
/**
 *  Wrapper for all ajax activity for Account Misc
 */
class MiscRepository {
    /**
     * Posts a completed event to track
     * @param {Object} info
     * @returns {axios.Promise}
     */
    trackEvent(info) {
        let eventData;
        if (info.pin && info.referenceNumber) {
            eventData = {
                eventType: info.event,
                eventData: {
                    referenceNumber: info.referenceNumber,
                    pin: info.pin,
                    success: "true",
                }
            };
        }
        else if (info.payableId) {
            eventData = {
                eventType: info.event,
                eventData: {
                    payableId: info.payableId,
                    success: "true"
                }
            };
        }
        else if (info.userId) {
            eventData = {
                eventType: info.event,
                eventData: {
                    userId: info.userId,
                    success: "true"
                }
            };
        }
        else {
            return Promise.reject("No user or account information present. Unable to send event tracking.");
        }
        if (info.channel != null) {
            eventData.eventData.channel = info.channel.toString();
        }
        return post(eventData);
    }
}
export default new MiscRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/misc/MiscRepository.ts